import { render, staticRenderFns } from "./RemoteControllerCreator.vue?vue&type=template&id=15fcaf44&scoped=true"
import script from "./RemoteControllerCreator.vue?vue&type=script&lang=js"
export * from "./RemoteControllerCreator.vue?vue&type=script&lang=js"
import style0 from "./RemoteControllerCreator.vue?vue&type=style&index=0&id=15fcaf44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fcaf44",
  null
  
)

export default component.exports